module.exports = __webpack_public_path__ + "468c5b74af21f1182770e60c5ff73714.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/support-business/CRM.svg
// module id = ./assets/images/support-business/CRM.svg
// module chunks = 0